const QueryRoleUseCountComponent = () => import('@/views/query/QueryRole/QueryRoleUseCountView')

export default [
    {
        path:'/QueryRoleUseCountIndex',
        name:'QueryRoleUseCountRouter',
        component:QueryRoleUseCountComponent
    }
]